import {
  ProductDetailsClient,
  ProductInputDto,
} from "@lib/ShiOneClient";
import { useApi } from "@utils/useApi";
import { useQuery } from "@tanstack/react-query";
import { OrdersQueryKeys } from "@features/orders-features/hooks/OrdersQueryKeys";
import { useMemo } from "react";
import ms from "ms";

export function useGetAvailabilityForProducts(
  orderId: number | undefined,
  productIds: ProductInputDto[],
) {
  const api = useApi(ProductDetailsClient);
  const fetch = async () => {
    if (productIds.length === 0) {
      return null;
    }
    return await api.getAvailabilityForProducts(productIds);
  };
  const productKey = useMemo(
    () =>
      productIds
        .map((p) => [
          (p.productDescriptor ?? "").toLowerCase(),
          (p.productClass ?? "").toLowerCase(),
        ])
        .sort((a, b) => {
          const left = `${a[0]}::${a[1]}`;
          const right = `${b[0]}::${b[1]}`;
          return left.localeCompare(right);
        }),
    [productIds],
  );
  return useQuery({
    queryKey: [
      OrdersQueryKeys.OrderLineProductAvailability,
      orderId,
      productKey,
    ],
    queryFn: fetch,
    enabled: !!orderId && productIds.length > 0,
    staleTime: ms("5m"),
    retry: false,
  });
}
